module.exports = __webpack_public_path__ + "static/media/Scada_Lite_logo-01.af98d95e.png";